import React, { useEffect, useState } from "react";
import close from "../../../assets/images/icons/close.png";
import {
  Card,
  Button,
  Col,
  Container,
  Row,
  Image,
  InputGroup,
  Table,
  Form as Forms,
} from "react-bootstrap";
import trash from "../../../assets/images/icons/trash.svg";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import earning from "../../../assets/images/icons/earning.png";
import Pic from "../../../assets/images/icons/user.png";

import {
  addNewBankDetails,
  getBankAccountList,
  myEarnings,
  deleteBankDetails,
  userTransactions,
} from "../../../utils/api";
import Modal from "react-awesome-modal";
import Loader from "../../../Loader/Loader";
import { toast } from "react-toastify";
import Lottie from "react-lottie";
import noDataLottie from "../../../assets/lottieFiles/noData.json";

const CoachEarningComponent = () => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: noDataLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const [totalEarnings, setTotalEarnings] = useState(0);
  const [showBankModal, setShowBankModal] = useState(false);
  const [showConfirmationModal, setConfirmationModal] = useState(false);
  const [bank_name, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [confirmAccountNumber, setConfirmAccountNumber] = useState("");
  const [accountHolder, setAccountHolder] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [bankDetails, setBankDetails] = useState(null);

  const getAllEarnings = async () => {
    try {
      const data = await myEarnings();
      setTotalEarnings(data.data.earning_amount);

      const bankData = await getBankAccountList();
      //   console.log(bankData);
      setBankDetails(bankData.data.data[0]);
    } catch (error) {
      console.log(error);
    }
    // console.log(data);
  };
  const getBankAccount = async () => {
    try {
      const bankData = await getBankAccountList();
      setBankDetails(bankData.data.data[0]);
    } catch (error) {
      console.log(error);
    }
    // console.log(data);
  };

  useEffect(() => {
    const canonicalUrl = window.location.origin + window.location.pathname;
    let link = document.querySelector("link[rel='canonical']");
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);

    getAllEarnings();
  }, []);

  const initialValues = {
    accountHolder: "",
    bankName: "",
    accountNumber: "",
    confirmAccountNumber: "",
    ifscCode: "",
  };

  const validationSchema = Yup.object({
    accountHolder: Yup.string().required("Account Holder Name is required."),
    bankName: Yup.string().required("Please select a bank."),
    accountNumber: Yup.string()
      .required("Account Number is required.")
      .matches(/^\d+$/, "Account Number must contain only numbers."),
    confirmAccountNumber: Yup.string()
      .oneOf([Yup.ref("accountNumber"), null], "Account numbers must match.")
      .required("Please confirm the Account Number."),
    ifscCode: Yup.string()
      .required("IFSC Code is required.")
      .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC Code format."),
  });

  const onSubmitHandler = async (values, { setSubmitting }) => {
    try {
      const payload = {
        account_holder_name: values.accountHolder,
        account_number: values.accountNumber,
        ifsc_code: values.ifscCode,
        bank_name: values.bankName,
      };

      const data = await addNewBankDetails(payload);
      if (data) {
        setShowBankModal(false);
        toast.success("Bank details added successfully!");
        getBankAccount();
      }
    } catch (error) {
      toast.error("Failed to add bank details.");
      console.error(error);
    } finally {
      setSubmitting(false);
    }
  };
  const [showConfirm, setShowConfirm] = useState(false);

  const handleDelete = () => {
    if (bankDetails) {
      handleDeleteSection(bankDetails?.id, bankDetails?.coach_id);
    }
    setShowConfirm(false); // Close modal after deletion
  };
  const handleDeleteSection = async (id, coach_id) => {
    try {
      const payload = {
        id: id,
        coach_id: coach_id,
      };

      const data = await deleteBankDetails(payload);
      if (data.data?.status) {
        toast.success(data.data.message);
        getBankAccount();
      } else {
        toast.error("Failed to delete bank details.");
      }
    } catch (error) {
      toast.error("Failed to delete bank details.");
      console.error(error);
    } finally {
    }
  };

  const [transactions, setTransactions] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Show 10 records per page

  useEffect(() => {
    getTransactionDetails(startDate, endDate);
  }, []);

  const getTransactionDetails = async () => {
    try {
      const userTransaction = await userTransactions({
        start_date: startDate,
        end_date: endDate,
      });
      setTransactions(userTransaction?.data?.data || []);
      console.log("userTransaction", userTransaction);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  useEffect(() => {
    if (startDate && endDate) {
      getTransactionDetails(startDate, endDate);
    }
  }, [startDate, endDate]);

  // **Pagination Logic**
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTransactions = transactions.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const totalPages = Math.ceil(transactions.length / itemsPerPage);

  return (
    <>
      <section className="">
        <div className="qoach_user_dark_bg_card">
          <Container>
            <Row className="align-items-center">
              <Col>
                <div className="d-flex align-items-center">
                  <img width="60" src={earning} alt="images" />
                  <div className="text-white ms-2">
                    <h4 className="m-0 fs-30 fw-600"> {totalEarnings} </h4>
                    <h6 className="m-0 fs-10 fw-500">Earning</h6>
                  </div>
                </div>
              </Col>
              <Col sm="auto">
                <Button variant="" className="text-white">
                  Bank Details
                </Button>
                <Button
                  className="px-5"
                  variant="success"
                  onClick={() => {
                    // if (bankDetails) {
                    //     setConfirmationModal(true);
                    // } else {
                    setShowBankModal(true);
                    // }
                  }}
                >
                  Add
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
        {/* {bankDetails !== null && bankDetails ? (
         
          <Row className="mt-3 justify-content-center">
            <Col md={12}>
              <Card className="p-4 shadow">
                <Card.Body>
                  <Row className="align-items-center">
                    <Col>
                      <h4 className="fs-20 fw-300">
                        Bank Name: {bankDetails?.bank_name}
                      </h4>
                      <h4 className="fs-20 fw-300">
                        Account Holder Name: {bankDetails?.account_holder_name}
                      </h4>
                      <h4 className="fs-20 fw-300">
                        Account Number: {bankDetails?.account_number}
                      </h4>
                      <h4 className="fs-20 fw-300">
                        IFSC Code: {bankDetails?.ifsc_code}
                      </h4>
                    </Col>
                    <Col xs="auto">
                      <Button style={{boxShadow: '0px 0px 10px 0px #cfcfcf'}}
                        className="mb-2"
                        variant="light"
                        onClick={() => setShowConfirm(true)}
                      >
                        <Image src={trash} />
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        ) : (
          <Col>
            <Lottie
              options={defaultOptions}
              height={300}
              width={400}
              isStopped={false}
              isPaused={false}
            />
          </Col>
        )} */}

        <Forms>
          <Row className="my-3 justify-content-between g-3">
            <Col md="5"></Col>
            <Col md="6">
              <div>
                <Forms.Group controlId="exampleForm.ControlInput1">
                  <InputGroup>
                    <Forms.Control
                      className="fs-14 calender"
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                    <InputGroup.Text>to</InputGroup.Text>
                    <Forms.Control
                      className="fs-14 calender"
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </InputGroup>
                </Forms.Group>
              </div>
            </Col>
          </Row>
        </Forms>

        <Card className="p-3 white_bg">
          <Table className="mt-2 align-middle borderless_td">
            <thead>
              <tr>
                <th>Program</th>
                <th>User</th>
                <th className="text-center">Amount</th>
                <th className="text-center">Plateform Fee</th>
                <th className="text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {currentTransactions.length > 0 ? (
                currentTransactions.map((transaction, index) => (
                  <tr key={index}>
                    <td>
                      <p className="m-0 fs-10 fw-400 brand_text_color7">
                        #{transaction.id}
                      </p>
                      <h5 className="fs-12 fw-500 text_brand_color7">
                        {transaction.session_title || "No Title"} <br />
                      </h5>
                    </td>
                    <td>
                      <div className="d-flex align-items-center pic_labels sm">
                        <div className="pic_labels_img">
                          <img
                            src={`${
                              process.env.REACT_APP_USER_PROFILE_FOLDER_PATH
                            }${transaction.profile_pic || Pic}`}
                            alt="Coach"
                            className="w-[2.6rem] h-[2.6rem] object-cover rounded-full"
                          />
                        </div>
                        <div className="flex-1 ms-1">
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <h5 className="m-0 text-black fs-14 fw-500">
                                {transaction.name || "Unknown Coach"}
                              </h5>
                              {transaction.professions &&
                                transaction.professions
                                  .split(",")
                                  .map((prof, i) => (
                                    <label key={i} className=" fs-12">
                                      {prof.trim()}
                                    </label>
                                  ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="text-center">
                      <h5 className="fs-16 fw-600">
                        ${transaction.total_payment || "0"}
                      </h5>

                      <h6 className="fs-12 fw-500">
                        {transaction.created_at
                          ? new Date(
                              transaction.created_at
                            ).toLocaleDateString()
                          : "N/A"}
                      </h6>
                    </td>
                    <td className="text-center">
                      <h5 className="fs-16 fw-600">
                        ${transaction?.total_payment * 0.05 || "0"}
                      </h5>
                    </td>

                    <td
                      className="text-center fs-12 fw-500 text"
                      style={{ color: "#139337" }}
                    >
                      <span className="p-1 border border-success text-success rounded-4">
                        {transaction.transaction_status || "Pending"}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination Controls */}
          {transactions.length > 10 && (
            <div className="mt-3 d-flex justify-content-center">
              <Button
                variant="outline-primary"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                className="me-2"
              >
                Previous
              </Button>
              <span className="align-self-center">{`Page ${currentPage} of ${totalPages}`}</span>
              <Button
                variant="outline-primary"
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className="ms-2"
              >
                Next
              </Button>
            </div>
          )}
        </Card>
      </section>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        visible={showBankModal}
        effect="fadeInUp"
        width="400"
        onClickAway={() => setShowBankModal(false)}
      >
        <Container>
          <Row className="justify-content-center">
            <Col sm="12">
              <div className="ls_modal_conatiner">
                <div
                  className="text-start text_brand_color2"
                  style={{ padding: "10px 0 10px" }}
                >
                  <h6 className="fs-20 fw-500 mx-50">Add Bank Account</h6>
                </div>
              </div>
            </Col>
            <Col>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmitHandler}
              >
                {({ isSubmitting }) => (
                  <Form className="row">
                    <div className="col-md-12">
                      <div className="mb-3 form-group">
                        <Field
                          type="text"
                          name="accountHolder"
                          className="form-control"
                          placeholder="Account Holder Name"
                        />
                        <ErrorMessage
                          name="accountHolder"
                          component="small"
                          className="text-danger"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3 form-group">
                        <Field
                          as="select"
                          name="bankName"
                          className="form-control"
                        >
                          <option value="" disabled>
                            Select Bank
                          </option>
                          <option value="JPMorgan Chase Bank">
                            JPMorgan Chase Bank
                          </option>
                          <option value="Bank of America">
                            Bank of America
                          </option>
                          <option value="Wells Fargo Bank">
                            Wells Fargo Bank
                          </option>
                          <option value="Citibank">Citibank</option>
                          <option value="U.S. Bank">U.S. Bank</option>
                          <option value="Truist Bank">Truist Bank</option>
                          <option value="PNC Bank">PNC Bank</option>
                          <option value="Capital One Bank">
                            Capital One Bank
                          </option>
                          <option value="TD Bank">TD Bank</option>
                          <option value="Charles Schwab Bank">
                            Charles Schwab Bank
                          </option>
                          <option value="Ally Bank">Ally Bank</option>
                          <option value="Regions Bank">Regions Bank</option>
                          <option value="Fifth Third Bank">
                            Fifth Third Bank
                          </option>
                          <option value="KeyBank">KeyBank</option>
                          <option value="Huntington National Bank">
                            Huntington National Bank
                          </option>
                        </Field>
                        <ErrorMessage
                          name="bankName"
                          component="small"
                          className="text-danger"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3 form-group">
                        <Field
                          type="text"
                          name="accountNumber"
                          className="form-control"
                          placeholder="Account Number"
                        />
                        <ErrorMessage
                          name="accountNumber"
                          component="small"
                          className="text-danger"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3 form-group">
                        <Field
                          type="text"
                          name="confirmAccountNumber"
                          className="form-control"
                          placeholder="Confirm Account Number"
                        />
                        <ErrorMessage
                          name="confirmAccountNumber"
                          component="small"
                          className="text-danger"
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="mb-3 form-group">
                        <Field
                          type="text"
                          name="ifscCode"
                          className="form-control"
                          placeholder="IFSC Code"
                        />
                        <ErrorMessage
                          name="ifscCode"
                          component="small"
                          className="text-danger"
                        />
                      </div>
                    </div>
                    <div className="mb-3 text-center col-md-12">
                      <button
                        className="px-5 btn primary-button"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? <Loader /> : "Submit"}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </Container>
      </Modal>

      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        visible={showConfirmationModal}
        effect="fadeInUp"
        width="400"
        onClickAway={() => setConfirmationModal(false)}
      >
        <Container>
          <Row className="justify-content-center">
            <Col sm="12">
              <div className="p-4 text-center ls_modal_conatiner">
                <h6 className="fs-20 fw-500">Bank account already exists.</h6>
                <p>Delete the existing account to add a new one.</p>
                <button
                  className="px-4 btn btn-primary"
                  onClick={() => setConfirmationModal(false)}
                >
                  OK
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>

      {/* Confirmation Modal */}
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        visible={showConfirm}
        effect="fadeInUp"
        width="400"
        onClickAway={() => setShowConfirm(false)}
      >
        <Container>
          <Row className="justify-content-center">
            <Col sm="12">
              <div className="p-4 text-center ls_modal_conatiner">
                <h5>Are you sure you want to delete this account?</h5>
                <div className="mt-3 d-flex justify-content-center">
                  <Button
                    variant="danger"
                    onClick={handleDelete}
                    className="mx-2"
                  >
                    Yes
                  </Button>
                  <Button
                    variant="secondary"
                    onClick={() => setShowConfirm(false)}
                  >
                    No
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>
    </>
  );
};

export default CoachEarningComponent;
